// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreWishlist = (client) => ({
    /**
     * `POST /store/wishlist`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCreateNewWishlist
     * @source packages/modules/b2c-core/src/api/store/wishlist/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/wishlist", { method: "POST", body, query, headers }),
    /**
     * `DELETE /store/wishlist/product/:reference_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreDeleteWishlist
     * @source packages/modules/b2c-core/src/api/store/wishlist/product/[reference_id]/route.ts
     */
    deleteProduct: (referenceId, body, query, headers) => client.fetch(buildPath("/store/wishlist/product/:reference_id", [referenceId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /store/wishlist`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetMyWishlist
     * @source packages/modules/b2c-core/src/api/store/wishlist/route.ts
     */
    list: (query, headers) => client.fetch("/store/wishlist", { method: "GET", query, headers }),
});
//# sourceMappingURL=wishlist.js.map